@use '@dixa/lib-shared-tokens/scss' as *;

.editor {
  height: 100%;
}

// Doubled to outrank Habla's own wrapper rule on specificity rather than on
// emit order, which Vite reverses. Stopgap: the real fix is for InputRichText
// to expose a way to style its wrapper (#10676).
.editorWrapper.editorWrapper {
  background-color: transparent;
}

.editorWrapper {
  &NoBorder {
    border: none;

    &:hover,
    &:focus,
    &:focus-within {
      // Override the default behavior of the editor
      // stylelint-disable-next-line
      box-shadow: none !important;
      // stylelint-disable-next-line
      border: none !important;
    }
  }
}

.editorRoot {
  padding: 0;
}
